module.exports = __webpack_public_path__ + "media/snap.003ce23a.mp3";